export default __webpack_public_path__ + "assets/darpa-logo.5d7582cf.png";